<!-- Button -->
<button mat-icon-button [matMenuTriggerFor]="userActions">
    <span class="relative pt-1">
        <img class="w-7 h-7 rounded-full" *ngIf="showAvatar && userAvatar" [src]="userAvatar">
        <mat-icon *ngIf="!showAvatar || !userAvatar" [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
    </span>
</button>

<mat-menu [xPosition]="'before'" #userActions="matMenu">
    <button mat-menu-item>
        <span class="flex flex-col leading-none">
            <span>Sesión de:</span>
            <span class="mt-1.5 text-md font-medium">{{userName}}</span>
        </span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <!-- <button mat-menu-item [routerLink]="['/']">
        <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        <span>Perfil</span>
    </button>
    <button mat-menu-item>
        <mat-icon [svgIcon]="'heroicons_outline:cog'"></mat-icon>
        <span>Configuración</span>
    </button>
    <mat-divider class="my-2"></mat-divider> -->
    <button mat-menu-item (click)="signOut()">
        <mat-icon [svgIcon]="'mat_outline:logout'"></mat-icon>
        <span>Salir</span>
    </button>
</mat-menu>
